<div class="normalScreen" style="background: white; overflow: hidden">
  <div class="admin-top">
    <div class="row">
      <div class="col-10">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="bi bi-truck-front mt-4 me-3" viewBox="0 0 16 16">
          <path d="M5 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-6-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H7Z" />
          <path fill-rule="evenodd" d="M4 2a1 1 0 0 0-1 1v3.9c0 .625.562 1.092 1.17.994C5.075 7.747 6.792 7.5 8 7.5c1.208 0 2.925.247 3.83.394A1.008 1.008 0 0 0 13 6.9V3a1 1 0 0 0-1-1H4Zm0 1h8v3.9c0 .002 0 .001 0 0l-.002.004a.013.013 0 0 1-.005.002h-.004C11.088 6.761 9.299 6.5 8 6.5s-3.088.26-3.99.406h-.003a.013.013 0 0 1-.005-.002L4 6.9c0 .001 0 .002 0 0V3Z" />
          <path fill-rule="evenodd" d="M1 2.5A2.5 2.5 0 0 1 3.5 0h9A2.5 2.5 0 0 1 15 2.5v9c0 .818-.393 1.544-1 2v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a2.496 2.496 0 0 1-1-2v-9ZM3.5 1A1.5 1.5 0 0 0 2 2.5v9A1.5 1.5 0 0 0 3.5 13h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 12.5 1h-9Z" />
        </svg>
        <h6 class="mt-2 d-inline-block">Bussar</h6>
      </div>
      <div class="col-sm-2 right-align-text">
        <button mat-flat-button class="upload-button" type="button" (click)="createNewBus()">
          <span style="font-size:22px">+&nbsp;</span>Ny buss
        </button>
      </div>

    </div>
  </div>
  <span></span>
  <div *ngIf="fetchingData"><em>Hämtar Bussar...</em></div>
  <div class="mt-3" style="width: 100%; height: 80%">
    <ag-grid-angular style="width: 100%; height: 100%;"                     
                     class="ag-theme-material ag-theme-schedule"
                     [gridOptions]="gridOptions"
                     [rowData]="bussData">
    </ag-grid-angular>
  </div>
</div>
